import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

type Variant = "default" | "glass" | "flat";

const variantClasses: Record<Variant, string> = {
  default:
    "bg-surface border border-white/[0.06] shadow-[0_1px_0_rgba(255,255,255,0.04)_inset,0_8px_24px_rgba(0,0,0,0.4)]",
  glass:
    "glass-strong",
  flat:
    "bg-surface-2 border border-white/[0.04]",
};

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: Variant;
  padded?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { variant = "default", padded = true, className, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        "rounded-[20px] overflow-hidden",
        variantClasses[variant],
        padded && "p-5",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
});

export function CardTitle({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={cn("text-[17px] font-semibold tracking-tight", className)}>{children}</div>
  );
}

export function CardDescription({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn("text-sm text-text-muted leading-snug", className)}>{children}</div>;
}
